import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  fetchLoginAttempts,
  fetchBlockedList,
  fetchLoginStats,
  unblockIP,
  unblockEmail,
  setFilter
} from '../../../Reducers/LoginAttempts/actions';
import moment from 'moment';

class LoginAttemptsPage extends Component {
  state = {
    refreshInterval: null,
    selectedTab: 'blocked' // 'blocked', 'attempts', 'stats'
  };

  componentDidMount() {
    this.loadAllData();
    this.setupAutoRefresh();
  }

  componentWillUnmount() {
    if (this.state.refreshInterval) {
      clearInterval(this.state.refreshInterval);
    }
  }

  loadAllData = () => {
    this.props.fetchBlockedList();
    this.props.fetchLoginStats(this.props.filters.hours || 24);
    if (this.state.selectedTab === 'attempts') {
      this.props.fetchLoginAttempts(this.props.filters);
    }
  };

  setupAutoRefresh = () => {
    // Auto refresh every 30 seconds
    const interval = setInterval(() => {
      this.loadAllData();
    }, 30000);
    this.setState({ refreshInterval: interval });
  };

  handleUnblockIP = async (ipAddress) => {
    if (window.confirm(`Weet je zeker dat je IP adres ${ipAddress} wilt deblokkeren?`)) {
      try {
        await this.props.unblockIP(ipAddress);
        // Show success message
        this.showMessage('success', `IP adres ${ipAddress} is succesvol gedeblokkeerd`);
      } catch (error) {
        this.showMessage('error', `Fout bij deblokkeren IP: ${error.message}`);
      }
    }
  };

  handleUnblockEmail = async (email) => {
    if (window.confirm(`Weet je zeker dat je email adres ${email} wilt deblokkeren?`)) {
      try {
        await this.props.unblockEmail(email);
        this.showMessage('success', `Email adres ${email} is succesvol gedeblokkeerd`);
      } catch (error) {
        this.showMessage('error', `Fout bij deblokkeren email: ${error.message}`);
      }
    }
  };

  handleFilterChange = (filterName, filterValue) => {
    this.props.setFilter(filterName, filterValue);
    
    // Reload data if necessary
    if (filterName === 'hours') {
      this.props.fetchLoginStats(filterValue);
    }
    if (this.state.selectedTab === 'attempts') {
      this.props.fetchLoginAttempts({
        ...this.props.filters,
        [filterName]: filterValue
      });
    }
  };

  showMessage = (type, message) => {
    // Simple alert for now - could be replaced with toast notifications
    alert(message);
  };

  handleTabChange = (tab) => {
    this.setState({ selectedTab: tab });
    if (tab === 'attempts' && this.props.attempts.length === 0) {
      this.props.fetchLoginAttempts(this.props.filters);
    }
  };

  renderStatsCards = () => {
    const { stats, loadingStats, statsError } = this.props;

    if (loadingStats) {
      return (
        <div className="row mb-4">
          <div className="col-12 text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Laden...</span>
            </div>
          </div>
        </div>
      );
    }

    if (statsError) {
      return (
        <div className="row mb-4">
          <div className="col-12">
            <div className="alert alert-danger">
              Fout bij laden statistieken: {statsError}
            </div>
          </div>
        </div>
      );
    }

    if (!stats) return null;

    return (
      <div className="row mb-4">
        <div className="col-md-2">
          <div className="card bg-primary text-white">
            <div className="card-body text-center">
              <h3 className="mb-0">{stats.total_attempts}</h3>
              <small>Totaal Pogingen</small>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-danger text-white">
            <div className="card-body text-center">
              <h3 className="mb-0">{stats.failed_attempts}</h3>
              <small>Mislukt</small>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-success text-white">
            <div className="card-body text-center">
              <h3 className="mb-0">{stats.successful_attempts}</h3>
              <small>Succesvol</small>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-info text-white">
            <div className="card-body text-center">
              <h3 className="mb-0">{stats.success_rate}%</h3>
              <small>Succespercentage</small>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-warning text-white">
            <div className="card-body text-center">
              <h3 className="mb-0">{stats.blocked_ips}</h3>
              <small>Geblokkeerde IPs</small>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-secondary text-white">
            <div className="card-body text-center">
              <h3 className="mb-0">{stats.blocked_emails}</h3>
              <small>Geblokkeerde Emails</small>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderBlockedList = () => {
    const { blockedIPs, blockedEmails, loadingBlocked, blockedError, unblockingIP, unblockingEmail } = this.props;

    if (loadingBlocked) {
      return (
        <div className="text-center p-4">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Laden...</span>
          </div>
        </div>
      );
    }

    if (blockedError) {
      return (
        <div className="alert alert-danger">
          Fout bij laden geblokkeerde lijst: {blockedError}
        </div>
      );
    }

    const totalBlocked = blockedIPs.length + blockedEmails.length;

    if (totalBlocked === 0) {
      return (
        <div className="alert alert-info">
          <i className="fas fa-info-circle me-2"></i>
          Geen geblokkeerde IP adressen of email adressen gevonden.
        </div>
      );
    }

    return (
      <div className="row">
        {/* Blocked IPs */}
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">
                <i className="fas fa-ban me-2 text-danger"></i>
                Geblokkeerde IP Adressen ({blockedIPs.length})
              </h5>
            </div>
            <div className="card-body">
              {blockedIPs.length === 0 ? (
                <p className="text-muted">Geen geblokkeerde IP adressen</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>IP Adres</th>
                        <th>Pogingen</th>
                        <th>Laatste Poging</th>
                        <th>Actie</th>
                      </tr>
                    </thead>
                    <tbody>
                      {blockedIPs.map(ip => (
                        <tr key={ip.ip_address}>
                          <td>
                            <code>{ip.ip_address}</code>
                          </td>
                          <td>
                            <span className="badge bg-danger">{ip.failed_attempts}</span>
                          </td>
                          <td>
                            <small className="text-muted">
                              {moment(ip.latest_attempt).fromNow()}
                            </small>
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-success"
                              onClick={() => this.handleUnblockIP(ip.ip_address)}
                              disabled={unblockingIP}
                            >
                              {unblockingIP ? (
                                <span className="spinner-border spinner-border-sm me-1"></span>
                              ) : (
                                <i className="fas fa-unlock me-1"></i>
                              )}
                              Deblokkeren
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Blocked Emails */}
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">
                <i className="fas fa-envelope me-2 text-danger"></i>
                Geblokkeerde Email Adressen ({blockedEmails.length})
              </h5>
            </div>
            <div className="card-body">
              {blockedEmails.length === 0 ? (
                <p className="text-muted">Geen geblokkeerde email adressen</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Email Adres</th>
                        <th>Pogingen</th>
                        <th>Laatste Poging</th>
                        <th>Actie</th>
                      </tr>
                    </thead>
                    <tbody>
                      {blockedEmails.map(email => (
                        <tr key={email.email}>
                          <td>
                            <code>{email.email}</code>
                          </td>
                          <td>
                            <span className="badge bg-danger">{email.failed_attempts}</span>
                          </td>
                          <td>
                            <small className="text-muted">
                              {moment(email.latest_attempt).fromNow()}
                            </small>
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-success"
                              onClick={() => this.handleUnblockEmail(email.email)}
                              disabled={unblockingEmail}
                            >
                              {unblockingEmail ? (
                                <span className="spinner-border spinner-border-sm me-1"></span>
                              ) : (
                                <i className="fas fa-unlock me-1"></i>
                              )}
                              Deblokkeren
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderLoginAttempts = () => {
    const { attempts, loading, error, pagination } = this.props;

    if (loading) {
      return (
        <div className="text-center p-4">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Laden...</span>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="alert alert-danger">
          Fout bij laden login attempts: {error}
        </div>
      );
    }

    if (attempts.length === 0) {
      return (
        <div className="alert alert-info">
          <i className="fas fa-info-circle me-2"></i>
          Geen login attempts gevonden voor de huidige filters.
        </div>
      );
    }

    return (
      <div>
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Tijd</th>
                <th>IP Adres</th>
                <th>Email</th>
                <th>Status</th>
                <th>User Agent</th>
                <th>Blocked Status</th>
              </tr>
            </thead>
            <tbody>
              {attempts.map(attempt => (
                <tr key={attempt._id}>
                  <td>
                    <small>{moment(attempt.attempt_time).format('DD/MM/YYYY HH:mm:ss')}</small>
                  </td>
                  <td>
                    <code>{attempt.ip_address}</code>
                    {attempt.ip_blocked && (
                      <span className="badge bg-danger ms-2">Blocked</span>
                    )}
                  </td>
                  <td>
                    {attempt.email ? (
                      <span>
                        {attempt.email}
                        {attempt.email_blocked && (
                          <span className="badge bg-danger ms-2">Blocked</span>
                        )}
                      </span>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                  <td>
                    <span className={`badge ${attempt.success ? 'bg-success' : 'bg-danger'}`}>
                      {attempt.success ? 'Success' : 'Failed'}
                    </span>
                  </td>
                  <td>
                    <small className="text-muted" title={attempt.user_agent}>
                      {attempt.user_agent ? attempt.user_agent.substring(0, 50) + '...' : '-'}
                    </small>
                  </td>
                  <td>
                    {attempt.is_blocked && (
                      <span className="badge bg-warning">Currently Blocked</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {pagination && pagination.pages > 1 && (
          <nav>
            <ul className="pagination justify-content-center">
              <li className={`page-item ${pagination.page <= 1 ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => this.handleFilterChange('page', Math.max(1, pagination.page - 1))}
                  disabled={pagination.page <= 1}
                >
                  Vorige
                </button>
              </li>
              <li className="page-item active">
                <span className="page-link">
                  Pagina {pagination.page} van {pagination.pages}
                </span>
              </li>
              <li className={`page-item ${pagination.page >= pagination.pages ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => this.handleFilterChange('page', Math.min(pagination.pages, pagination.page + 1))}
                  disabled={pagination.page >= pagination.pages}
                >
                  Volgende
                </button>
              </li>
            </ul>
          </nav>
        )}
      </div>
    );
  };

  render() {
    const { selectedTab } = this.state;
    const { filters } = this.props;

    return (
      <div className="box box-default">
        <div className="box-header with-border">
          <h3 className="box-title">Login Attempts Beheer</h3>
          <div className="box-tools pull-right">
            <button
              className="btn btn-sm btn-primary"
              onClick={this.loadAllData}
            >
              <i className="fas fa-sync-alt me-1"></i>
              Vernieuwen
            </button>
          </div>
        </div>

        {/* Simple button navigation */}
        <div className="mb-4">
          <div className="simple-nav-buttons">
            <button 
              className={`simple-nav-btn ${selectedTab === 'blocked' ? 'active' : ''}`}
              onClick={() => this.handleTabChange('blocked')}
              type="button"
            >
              Geblokkeerd ({this.props.totalBlocked})
            </button>
            <button 
              className={`simple-nav-btn ${selectedTab === 'attempts' ? 'active' : ''}`}
              onClick={() => this.handleTabChange('attempts')}
              type="button"
            >
              Alle Attempts
            </button>
            <button 
              className={`simple-nav-btn ${selectedTab === 'stats' ? 'active' : ''}`}
              onClick={() => this.handleTabChange('stats')}
              type="button"
            >
              Statistieken
            </button>
          </div>

          {/* Tab content */}
          <div className="tab-content">
            {/* Stats Cards */}
            {this.renderStatsCards()}

            {/* Filters */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Periode</label>
                <select
                  className="form-select"
                  value={filters.hours || 24}
                  onChange={(e) => this.handleFilterChange('hours', parseInt(e.target.value))}
                >
                  <option value={1}>Laatste uur</option>
                  <option value={6}>Laatste 6 uur</option>
                  <option value={24}>Laatste 24 uur</option>
                  <option value={72}>Laatste 3 dagen</option>
                  <option value={168}>Laatste week</option>
                </select>
              </div>
            </div>

            {/* Blocked tab */}
            {selectedTab === 'blocked' && (
              <div className="tab-pane fade show active">
                <div className="box box-default">
                  <div className="box-body">
                    {this.renderBlockedList()}
                  </div>
                </div>
              </div>
            )}

            {/* Attempts tab */}
            {selectedTab === 'attempts' && (
              <div className="tab-pane fade show active">
                <div className="box box-default">
                  <div className="box-body">
                    {this.renderLoginAttempts()}
                  </div>
                </div>
              </div>
            )}

            {/* Stats tab */}
            {selectedTab === 'stats' && (
              <div className="tab-pane fade show active">
                <div className="box box-default">
                  <div className="box-body">
                    <div className="alert alert-info">
                      <i className="fas fa-info-circle me-2"></i>
                      Statistieken worden getoond in de kaarten bovenaan de pagina.
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const loginAttempts = state.loginAttempts || {};
  return {
    // Login attempts data
    attempts: loginAttempts.attempts || [],
    pagination: loginAttempts.pagination || {},
    filters: loginAttempts.filters || {},
    
    // Blocked list
    blockedIPs: loginAttempts.blockedIPs || [],
    blockedEmails: loginAttempts.blockedEmails || [],
    totalBlocked: loginAttempts.totalBlocked || 0,
    
    // Statistics
    stats: loginAttempts.stats,
    
    // Loading states
    loading: loginAttempts.loading || false,
    loadingBlocked: loginAttempts.loadingBlocked || false,
    loadingStats: loginAttempts.loadingStats || false,
    unblockingIP: loginAttempts.unblockingIP || false,
    unblockingEmail: loginAttempts.unblockingEmail || false,
    
    // Error states
    error: loginAttempts.error,
    blockedError: loginAttempts.blockedError,
    statsError: loginAttempts.statsError,
    unblockError: loginAttempts.unblockError
  };
}

const mapDispatchToProps = {
  fetchLoginAttempts,
  fetchBlockedList,
  fetchLoginStats,
  unblockIP,
  unblockEmail,
  setFilter
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginAttemptsPage);